import { Sucursal } from '../sucursal/sucursal';
import { Rol } from '../rol/rol'
export class Usuario {
    _id: string;
    usuario: string;
    password: string;
    nombre: string;
    apellido: string;
    dni:number;
    estado:boolean
    puesto: string;
    email: string;
    celular: string;
    recibirSinActividad: boolean;
    rol: any;
    sucursales: Sucursal[];
    sinactividad: any;
    calibracion: any;
    rango: any;
    bateria: any;
    sensornull: any;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/usuarios/usuario.ts